import Loadable from 'UIComponents/decorators/Loadable';
const AsyncMessageHandlers = Loadable({
  loader: () => import( /* webpackChunkName: "message-handlers" */'./MessageHandlers').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncMessageHandlers;